import React from 'react';

export const DualRangeInput = (props) => (
	<div className={props.className}>
		<span className="label">{props.label}</span>
		<input 
			type="number" 
			name={props.fromName} 
			id={props.fromName} 
			placeholder={props.fromLabel} 
			min={props.min}
			max={props.max}
			onChange={props.handleInputChange} /> 
		<span className="dash-divider"></span>
		<input 
			type="number" 
			name={props.toName} 
			id={props.toName} 
			placeholder={props.toLabel} 
			min={props.min} 
			max={props.max} 
			onChange={props.handleInputChange} />
	</div>
);


// WEBPACK FOOTER //
// ./src/components/DualRangeInput/DualRangeInput.js